import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import { formatDate } from 'utils/formatter';
import { getDate } from 'components/features/utils/converter';

export const AggregateDataErrorModal = ({
  hide,
  isShow,
  day,
  isYear,
}: {
  hide: () => void;
  isShow: boolean;
  day: number;
  isYear: boolean;
}) => {
  const date = isYear
    ? formatDate(getDate(day), 'yyyy/MM')
    : formatDate(getDate(day), 'yyyy/MM/dd');
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className={`flex flex-col p-4 text-sm`}>
          <div
            className="icon-close ml-auto text-right text-gray-500 cursor-pointer"
            onClick={hide}
          />
          <div className="mt-2">
            集計が正常に完了しなかった可能性があるためこのデータは参考値です。
          </div>
          <div className="mt-2">{date}</div>
          <button
            onClick={hide}
            className="bg-white p-4 px-8 text-sm flex justify-center items-center">
            閉じる
          </button>
        </div>
      </Modal2>
    </>
  );
};
